import * as Icons from "@nova/component-icons"
import { TriCheckbox } from "@nova/component-checkbox"
import classNames from "classnames"
import { CommentImageThumbnail } from "./CommentImageThumbnail"
import { useCommentImageUpload } from "./useCommentImageUpload"

export const CommentImageComposeStrip = ({
    imageUpload,
}: {
    imageUpload: ReturnType<typeof useCommentImageUpload>
}) => {
    if (imageUpload.images.length === 0) return null

    return (
        <>
            <div className="flex flex-wrap items-center gap-1 px-2 py-2">
                {imageUpload.images.map((image) => {
                    const selected = imageUpload.selectedIds.includes(image.id)
                    return (
                        <CommentImageThumbnail
                            key={image.id}
                            url={image.previewUrl}
                            status={image.status}
                            onClick={() => imageUpload.toggleSelect(image.id)}
                        >
                            <span
                                data-active={selected}
                                className={classNames(
                                    "absolute left-1 top-1 opacity-0 transition-opacity group-hover/image:opacity-100 data-[active=true]:opacity-100"
                                )}
                            >
                                <TriCheckbox
                                    state={selected ? "checked" : "unchecked"}
                                    className="!bg-gray-800"
                                />
                            </span>
                        </CommentImageThumbnail>
                    )
                })}
            </div>
            {imageUpload.selectedIds.length > 0 && (
                <div className="px-4 pb-2">
                    <button
                        type="button"
                        onClick={imageUpload.removeSelected}
                        className="flex w-full items-center justify-center gap-1 rounded-lg border border-red-700 px-3 py-1.5 text-red-200 hover:bg-red-700/20"
                    >
                        <Icons.SmallIcon Icon={Icons.ClearAll} className="size-5" />
                        <span className="text-sm">Remove Selected Image</span>
                    </button>
                </div>
            )}
        </>
    )
}
